import { TemplateRef } from "@angular/core";

export enum IAlertTypes {
  success = 'success',
  danger = 'danger',
  warning = 'warning',
  info = 'info',
}

export interface IAlert {
  id: string;
  duration?: number;
  type: IAlertTypes;
  heading: string;
  body?: string;
  bodyTemplate?: TemplateRef<any>;
  local?: boolean;
  dismissable?: boolean;
  actions?: IAlertAction[];
  time?: number;
}

export interface IAlertAction {
  label: string;
  action: (data?: unknown) => void;
}
